import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import CommonLoader from '../../../../components/common-loader/CommonLoader';
import CommonPagination from '../../../../components/common-pagination/CommonPagination';
import SourceImageModal from '../../../../id8/components/source-image-modal/SourceImageModal';
import { REACTIONS } from '../../../../constants';
import Disclaimer from './disclaimer/Disclaimer';
import { changeTableSettings, likeDemoImage } from '../../../../redux/demo-recreate/demoRecreateReducer';
import useLocalTable from '../../../../hooks/useLocalTable';
import FrameCard from './card/FrameCard';
import PreviewModal from './preview-modal/PreviewModal';

import scss from './RecreateOutput.module.scss';

function RecreateOutput() {
  const dispatch = useDispatch();

  const [imagesPreview, setImagesPreview] = useState(null);
  const [sourceImageId, setSourceImageId] = useState('');

  const imagesContent = useSelector((state) => state.demoRecreate.imagesContent);
  const { page, size } = useSelector((state) => state.demoRecreate.imagesTableSettings);
  const isGenerating = useSelector((state) => state.demoRecreate.isGenerating);

  const { content, totalElements } = useLocalTable({ content: imagesContent, tableSettings: { page, size } });

  const handleClosePreview = () => {
    setImagesPreview(null);
  };

  const handleOpenPreview = (frameData) => {
    setImagesPreview(frameData);
  };

  const handleShowSourceImage = (prompt) => {
    setSourceImageId(prompt.sourceImageKey);
  };

  const handleCloseSourceImageModal = () => {
    setSourceImageId('');
  };

  const handleChangePage = (newPage) => {
    dispatch(changeTableSettings({ page: newPage + 1 }));
  };

  const handleLike = (likedImage) => {
    dispatch(
      likeDemoImage({
        sessionId: likedImage.sessionId,
        newReaction: likedImage.reaction === REACTIONS.LIKE ? '' : REACTIONS.LIKE,
      }),
    );
  };

  useEffect(() => {
    if (content) {
      const updatedFrameData = content.find((frame) => frame.sessionId === imagesPreview?.sessionId);
      if (updatedFrameData) {
        setImagesPreview(updatedFrameData);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [content]);

  return (
    <div className={scss.wrapper}>
      {content?.length ? (
        <div className={scss.cardsWrapper}>
          {content.map((frameData) => (
            <FrameCard
              key={frameData.sessionId}
              frameData={frameData}
              onPreview={handleOpenPreview}
              onLike={handleLike}
              onShowSourceImage={handleShowSourceImage}
            />
          ))}

          <CommonLoader isLoading={isGenerating} />
        </div>
      ) : null}

      <div className={scss.paginationWrapper}>
        <Disclaimer />

        <CommonPagination
          activePage={page - 1}
          itemsPerPage={size}
          totalItemsCount={totalElements}
          onChangePage={handleChangePage}
        />
      </div>

      <PreviewModal
        isOpen={imagesPreview}
        onClose={handleClosePreview}
        frameData={imagesPreview}
        onLike={handleLike}
        onShowSourceImage={handleShowSourceImage}
      />

      <SourceImageModal
        isOpen={!!sourceImageId}
        onClose={handleCloseSourceImageModal}
        sourceImageId={sourceImageId}
        onGetImage={() => null}
      />
    </div>
  );
}

export default RecreateOutput;
